import { useOutletContext } from 'react-router-dom';

import { Roster } from '../Roster';
import type { LeagueContext } from '../LeagueWorkspace';

/** The roster, which was the whole league page until there were tabs to put it in. */
export function RosterTab() {
  const { league } = useOutletContext<LeagueContext>();
  return <Roster leagueId={league.id} playerCap={league.playerCap} timeZone={league.timeZone} />;
}
